import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IonButton, IonIcon } from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import { addIcons } from 'ionicons';
import { refreshOutline } from 'ionicons/icons';

import { AppUpdateService } from '../../../services/infrastructure/app-update/app-update.service';

/**
 * Aviso flotante de versión nueva. Vive en el marco de la aplicación y se
 * pinta solo cuando el service worker ya descargó una versión nueva.
 *
 * **No se puede cerrar:** actualizar es necesario, así que el aviso se queda
 * hasta que el usuario pulsa "Actualizar ahora".
 */
@Component({
  selector: 'app-update-notice',
  templateUrl: './app-update-notice.component.html',
  styleUrls: ['./app-update-notice.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonButton, IonIcon, TranslatePipe],
})
export class AppUpdateNoticeComponent {
  protected readonly appUpdate = inject(AppUpdateService);

  constructor() {
    addIcons({ refreshOutline });
  }
}
